module.exports = __webpack_public_path__ + "img/hometop_md.732cbe80.png";